module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHUAAAAGCAYAAAD9stHTAAABAklEQVRIS+WWzUpCURSFv9VAGtfIHqg/0CewUeC0DCKbOSsL0hdw1BsoWPZA1qTGIcSWUxHc48UO3o2D6xl/e++19oLDFiV61qHCJ/eIBoaAR7a5VIdZiWz+a0Xnw/0jSYNAmtlpv/7ylFeVyoXaVNabszZ94CzS39Ut7diT92zvfkX2qNboYIpR/TYtXnu1yV5eqKlcqE1lvTm75h1jJ6NffOiG3diT92zvfkX2mA0V3nr1yU/A0cuIXsItiHHomTp75VDXqDHVS5E96mJ0eGxmA7Avaav5UHse54WayoXaVNaby/1+jTt1uYo9ec/27ldkj+GYKM37O5Tg5NfURh5KczdBYiCBoqlZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/image/xzdiandian@2x.png
// module id = gW7k
// module chunks = 19